module.exports = __webpack_public_path__ + "static/media/physiotherapie-desktop.a504ba8a.jpg";